import React, { useEffect } from 'react';
import { Routes, Route, useLocation, matchPath } from 'react-router-dom';
import Home from './views/Home';
import Header from './layout/Header';
import Main from './layout/Main';
import Footer from './layout/Footer';
import { VStack, Spacer } from '@chakra-ui/react';

import Vote2 from './views/LegendsVote';

import { LRanking } from './views/LRanking';
import About from './views/Home';

import ClickerGame from './views/game/Clicker/ClickerGame';

import Wallet from './views/Wallet';
import Sniper from './views/TradingBots/SniperBot';
import SniperTriangle from './views/TradingBots/SniperBotTriangle';
import FlashArbBot from './views/TradingBots/FlashArbBot';
import BotLiveStats from './views/TradingBots/BotLiveStats';

import Bank from './views/TradingBots/bank';

import croham from './assets/crohamcity.webp';
import { Nfts } from './views/Nfts';

import GameLoader from './views/GameLoader';

import RampageOneManArmy_R3 from './views/game/OneManArmy';

import DemoGameLoader from './views/GameLoader_demo';
import Demo from './views/game/Demo';

import Casino from './views/casino/SlotGame';
import News from './views/news';
import AssetExecutionDashboard from './views/AssetExecutionDashboard';


const HUB_BASE = (process.env.REACT_APP_SISUFORGE_URL || 'https://sisuforge.com').replace(/\/$/, '');

/** Old bookmarks to /crypto-tax-fi or /travel-buddy on Croham → same path on Sisu Forge hub */
function HubPathRedirect() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    window.location.replace(HUB_BASE + pathname + search + hash);
  }, [pathname, search, hash]);
  return null;
}

function CrohamRoutes() {
  return (
    <Routes>
      <Route index element={<Home />} />

      <Route path="Rampage/" element={<GameLoader />} />
      <Route path="Rampage/Demo" element={<DemoGameLoader />} />
      <Route path="About" element={<About />} />
      <Route path="news" element={<News />} />
      <Route path="crypto-tax-fi" element={<HubPathRedirect />} />
      <Route path="travel-buddy/*" element={<HubPathRedirect />} />
      <Route path="Rampage/DemoGame" element={<Demo />} />
      <Route path="Rampage/Game" element={<RampageOneManArmy_R3 />} />
      <Route path="Wallet" element={<Wallet />} />
      <Route path="Casino" element={<Casino />} />
      <Route path="ClickerGame" element={<ClickerGame />} />
      <Route path="bank" element={<Bank />} />
      <Route path="asset-execution" element={<AssetExecutionDashboard />} />
      <Route path="vote" element={<Vote2 />} />

      <Route path="nfts" element={<Nfts />} />
      <Route path="ranking" element={<LRanking />} />

      <Route path="About" element={<About />} />

      <Route path="/Tracker" element={<Wallet />} />
      <Route path="/donotuse" element={<SniperTriangle />} />
      <Route path="/triangle-bots" element={<SniperTriangle />} />
      <Route path="/legacy-sniper" element={<Sniper selectedTokenAddress="" />} />
      <Route path="bot-stats" element={<BotLiveStats />} />
      <Route path="/bot-stats" element={<BotLiveStats />} />
      <Route path="flash-arb" element={<FlashArbBot />} />
      <Route path="/flash-arb" element={<FlashArbBot />} />

      <Route path="ClickerGame" element={<ClickerGame />} />
    </Routes>
  );
}

function App() {
  const location = useLocation();
  const isPublicBotStats = Boolean(
    matchPath({ path: '/bot-stats', end: true }, location.pathname) ||
      matchPath({ path: 'bot-stats', end: true }, location.pathname)
  );

  if (isPublicBotStats) {
    return <BotLiveStats />;
  }

  return (
    <VStack
      alignSelf="center"
      alignItems="center"
      width="100%"
      minHeight="100vh"
      backgroundImage={croham}
      backgroundSize="cover"
      backgroundRepeat="no-repeat"
    >
      <Header />
      <Main>
        <CrohamRoutes />
      </Main>
      <Spacer />
      <Footer />
    </VStack>
  );
}

export default App;
